import { NEWBUILDING_CONSULTANT_MESSAGE_BUTTON } from '../../constants/experiments';
import { IApplicationState } from '../../types/redux';
import { isAbUseExperimentGroup } from '../../utils/experiments';
import { getBuilderChatEnabled } from '../builderChat';
import { getIsUpcomingSale } from '../newbuilding';

export function isConsultantChatOpenedSelector(state: IApplicationState) {
  return state.consultantChat.isOpen;
}

export const selectWebimAccountName = (state: IApplicationState) => state.settings.webimAccountName;

export const selectWebimHost = (state: IApplicationState) => state.settings.webimHost;

// TODO: Удалить лишние проверки в CD-225147.
export const selectConsultantMessageButtonAvailable = (state: IApplicationState): boolean => {
  const { settings, abUseExperiments } = state;

  return (
    settings.isConsultantMessageButtonEnabled &&
    Boolean(settings.webimAccountName) &&
    !getIsUpcomingSale(state) &&
    !getBuilderChatEnabled(state) && // TODO: В CD-225147 не делать эту проверку для ЖК на КпН.
    isAbUseExperimentGroup(abUseExperiments, NEWBUILDING_CONSULTANT_MESSAGE_BUTTON, 'B')
  );
};
